<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span>Gestionar Perfiles del Usuario <span class="badge">{{original.numero_empleado}}--{{original.nombre_empleado}}</span></span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row mt-3">
      <div class="col-md-3" v-for="p in datosRegistro.lstPerfiles" :key="p.id_perfil">
        <div class="form-check form-switch" >
          <input class="form-check-input" type="checkbox" role="switch" :id="'switch-'+p.id_perfil" v-model="p.asignado"
                 @change="actualizar(p)">
          <label class="form-check-label" :for="'switch-'+p.id_perfil">{{p.nombre_perfil}}</label>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col" align="center">
        <button class="btn btn-info " @click="cancelar()">Regresar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {UsuarioPerfilService} from "@/services/UsuarioPerfilService";

export default {
  components: {},

  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_UsuarioPerfilService: new UsuarioPerfilService(inject('$axios'))
    }
  },
  props: {
    original: Object
  },
  data() {
    return {
      datosRegistro: {
        id_empleado: null,
        lstPerfiles: []
      }
    }
  },
  mounted() {
    if (this.original != null && this.original.id != null) {
      this.obtener();
    }
  },
  methods: {
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_UsuarioPerfilService.obtener({id_empleado: ""+this.original.id}).then((response) => {
        this.datosRegistro.id_empleado = this.original.id;
        this.datosRegistro.lstPerfiles = response
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async actualizar(item) {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      const params = {
        id_empleado: this.datosRegistro.id_empleado,
        id_perfil: item.id_perfil
      }

      if (item.asignado != null && item.asignado) {

        await this.srv_UsuarioPerfilService.registro(params).then(() => {

        }).catch((error) => {
          item.asignado = false;
          console.error(error)
          this.$swal(error.message);
        }).finally(() => load.hide());

      } else {

        await this.srv_UsuarioPerfilService.eliminar(params).then(() => {

        }).catch((error) => {
          item.asignado = true;
          console.error(error)
          this.$swal(error.message);
        }).finally(() => load.hide());

      }
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    }
  }
}
</script>

<style scoped>
  .badge {
    font-weight: bolder;
    border: solid white;
    border-radius: 20px;
    padding: 3px;
  }
</style>